// @flow

import {
  SS_CLEAR_EXTRACTED_STYLES,
  SS_MARK_APPLIED_STYLES,
  SS_CLOSE_ERROR_FETCHING_MODAL,
  SS_BACKUP_TEMPLATE_SETTINGS,
  SS_EXTRACT_STYLES_REQUEST,
  SS_EXTRACT_STYLES_SUCCESS,
  SS_EXTRACT_STYLES_FAILURE,
  SS_APPLY_STYLES_REQUEST,
  SS_APPLY_STYLES_SUCCESS,
  SS_APPLY_STYLES_FAILURE,
  SS_EXTRACT_AND_APPLY_STYLES_REQUEST,
  SS_EXTRACT_AND_APPLY_STYLES_SUCCESS,
  SS_EXTRACT_AND_APPLY_STYLES_FAILURE,
  SS_EXTRACT_AND_APPLY_STYLES_OPENAI_REQUEST,
  SS_EXTRACT_AND_APPLY_STYLES_OPENAI_SUCCESS,
  SS_EXTRACT_AND_APPLY_STYLES_OPENAI_FAILURE,
  SmartStylingState,
  SmartStylingAction
} from 'stores/flow-type/shopify-integration/smart-styling.type';

const initialState: SmartStylingState = {
  extractStylesLoading: false,
  extractStylesError: false,
  extractStylesSuccess: false,
  extractedStyles: {},

  applyStylesLoading: false,
  applyStylesSuccess: false,

  extractAndApplyStylesLoading: false,
  extractAndApplyStylesSuccess: false,

  updatedTemplateSettings: {},
  backupTemplateSettings: {},

  appliedStyles: false
};

const smartStylingReducers = (
  state: SmartStylingState = initialState,
  action: SmartStylingAction
) => {
  switch (action.type) {
    case SS_EXTRACT_STYLES_REQUEST:
      return {
        ...state,
        extractStylesLoading: true,
        extractStylesSuccess: false,
        extractStylesError: false,
        extractedStyles: {}
      };
    case SS_EXTRACT_STYLES_SUCCESS: {
      const { data = {} } = action.payload;

      return {
        ...state,
        extractStylesLoading: false,
        extractStylesSuccess: true,
        extractStylesError: false,
        extractedStyles: data
      };
    }
    case SS_EXTRACT_STYLES_FAILURE:
      return {
        ...state,
        extractStylesLoading: false,
        extractStylesSuccess: false,
        extractStylesError: true,
        error: action.payload
      };

    // Apply styles
    case SS_APPLY_STYLES_REQUEST:
      return {
        ...state,
        applyStylesLoading: true,
        applyStylesSuccess: false,
        updatedTemplateSettings: {}
      };
    case SS_APPLY_STYLES_SUCCESS: {
      const { data = {} } = action.payload;
      const reduxFormData = data?.data?.value || {};

      const updatedTemplateSettings = {
        setting: reduxFormData,
        colors: data?.data?.colors,
        typography: data?.data?.typography,
        pagination: data?.data?.pagination
      };

      return {
        ...state,
        applyStylesLoading: false,
        applyStylesSuccess: true,
        updatedTemplateSettings
      };
    }
    case SS_APPLY_STYLES_FAILURE:
      return {
        ...state,
        applyStylesLoading: false,
        applyStylesSuccess: false,
        updatedTemplateSettings: {},
        error: action.payload
      };

    // Extract and apply styles
    case SS_EXTRACT_AND_APPLY_STYLES_REQUEST:
      return {
        ...state,
        extractAndApplyStylesLoading: true,
        extractAndApplyStylesSuccess: false,
        extractAndApplyStylesError: false,
        extractedStyles: {},
        updatedTemplateSettings: {}
      };
    case SS_EXTRACT_AND_APPLY_STYLES_SUCCESS: {
      const { data = {} } = action.payload;
      const reduxFormData = data?.data?.value || {};

      const updatedTemplateSettings = {
        setting: reduxFormData,
        colors: data?.data?.colors,
        typography: data?.data?.typography,
        pagination: data?.data?.pagination
      };

      return {
        ...state,
        extractAndApplyStylesLoading: false,
        extractAndApplyStylesSuccess: true,
        extractAndApplyStylesError: false,
        extractedStyles: data?.extractedStyles,
        updatedTemplateSettings
      };
    }
    case SS_EXTRACT_AND_APPLY_STYLES_FAILURE:
      return {
        ...state,
        extractAndApplyStylesLoading: false,
        extractAndApplyStylesSuccess: false,
        extractAndApplyStylesError: true,
        updatedTemplateSettings: {},
        error: action.payload
      };

    // Extract and apply styles
    case SS_EXTRACT_AND_APPLY_STYLES_OPENAI_REQUEST:
      return {
        ...state,
        extractAndApplyStylesOpenAILoading: true,
        extractAndApplyStylesOpenAISuccess: false,
        extractAndApplyStylesOpenAIError: false,
        extractedStyles: {},
        updatedTemplateSettings: {}
      };
    case SS_EXTRACT_AND_APPLY_STYLES_OPENAI_SUCCESS: {
      const { data = {} } = action.payload;
      const reduxFormData = data?.data?.value || {};

      console.log('SS_EXTRACT_AND_APPLY_STYLES_OPENAI_SUCCESS', data);

      const updatedTemplateSettings = {
        setting: reduxFormData,
        colors: data?.data?.colors,
        typography: data?.data?.typography,
        pagination: data?.data?.pagination
      };

      return {
        ...state,
        extractAndApplyStylesOpenAILoading: false,
        extractAndApplyStylesOpenAISuccess: true,
        extractAndApplyStylesOpenAIError: false,
        extractedStyles: data?.extractedStyles,
        updatedTemplateSettings
      };
    }
    case SS_EXTRACT_AND_APPLY_STYLES_OPENAI_FAILURE:
      return {
        ...state,
        extractAndApplyStylesOpenAILoading: false,
        extractAndApplyStylesOpenAISuccess: false,
        extractAndApplyStylesOpenAIError: true,
        updatedTemplateSettings: {},
        error: action.payload
      };

    // Backup template settings
    case SS_BACKUP_TEMPLATE_SETTINGS: {
      const { data = {} } = action.payload;
      return {
        ...state,
        backupTemplateSettings: data
      };
    }

    // Clear extracted styling
    case SS_CLEAR_EXTRACTED_STYLES: {
      return {
        ...state,
        extractedStyles: {},
        backupTemplateSettings: {}
      };
    }

    // Mark applied styles
    case SS_MARK_APPLIED_STYLES: {
      return {
        ...state,
        appliedStyles: true
      };
    }

    // Mark applied styles
    case SS_CLOSE_ERROR_FETCHING_MODAL: {
      return {
        ...state,
        extractStylesError: false,
        extractAndApplyStylesError: false,
        extractAndApplyStylesOpenAIError: false
      };
    }

    default:
      return state;
  }
};
export default smartStylingReducers;
